import { type ValueOf, without } from '@evc/web-components';

export const NAVIGATIONS_MENUS = {
  APPS: 'apps',
  HELP: 'help',
  LANGS: 'langs',
  SETTINGS: 'settings',
  USER: 'user',
} as const;
export type NavigationsMenu = ValueOf<typeof NAVIGATIONS_MENUS>;

export const NAVIGATIONS_MODES = {
  /** display login cta + lang switcher but no help/settings menus */
  PUBLIC: 'public',
  /** display help/settings menus + user-menu + apps-menu */
  PRIVATE: 'private',
  /** mix of both modes : show all menus according to provided inputs to platform
   * can be used for custom implementation
   * but if integrated with connect platform we really recommand to keep PUBLIC/PRIVATE only
   */
  LEGACY: 'legacy',
} as const;
export type NavigationsMode = ValueOf<typeof NAVIGATIONS_MODES>;

export const NAVIGATIONS_HOSTS = {
  TOPBAR: 'topbar',
  BURGER: 'burger',
  LEFTBAR: 'leftbar',
} as const;
export type NavigationsHost = ValueOf<typeof NAVIGATIONS_HOSTS>;

export const PRIMARY_NAVIGATION_HOSTS = without(NAVIGATIONS_HOSTS, 'LEFTBAR');
export type PrimaryNavigationHosts = ValueOf<typeof PRIMARY_NAVIGATION_HOSTS>;

export const SECONDARY_NAVIGATION_HOSTS = without(NAVIGATIONS_HOSTS, 'TOPBAR');
export type SecondaryNavigationHosts = ValueOf<typeof SECONDARY_NAVIGATION_HOSTS>;

export const TERTIARY_NAVIGATION_HOSTS = without(NAVIGATIONS_HOSTS, 'LEFTBAR');
export type TertiaryNavigationHosts = ValueOf<typeof TERTIARY_NAVIGATION_HOSTS>;
